import React, { useState, useEffect } from "react";
import {
  useTranslate,
  List,
  Create,
  TextInput,
  Edit,
  SimpleForm,
  useRedirect,
  useListContext,
} from "react-admin";
import {
  Container,
  Content,
  HeaderRow,
  Title,
  Actions,
  ListCard,
  SortableList as SortableListUI,
  SortableItem as SortableItemUI,
  SortableLink,
  DragIconWrap,
  ListHint,
  FormCard,
  CreateButton,
} from "./styles";
import { DragIndicator } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";

import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";
import arrayMove from "array-move";
import { updateAll } from "../../Providers/CategoryProvider";

export const CategoryList = (props: any) => {
  const translate = useTranslate();

  const DragHandle = SortableHandle(() => (
    <DragIconWrap title="Arraste para reordenar">
      <DragIndicator style={{ pointerEvents: "none", height: 24 }} />
    </DragIconWrap>
  ));

  const SortableItem = SortableElement((props: any) => (
    <SortableItemUI>
      <DragHandle />
      <SortableLink to={`/category/${props.value.id}`}>
        {props.value.name}
      </SortableLink>
    </SortableItemUI>
  ));

  const SortableList = SortableContainer((props: any) => {
    return (
      <SortableListUI>
        {props.items.map((value: any, index: any) => (
          <SortableItem key={`item-${value.id}`} index={index} value={value} />
        ))}
      </SortableListUI>
    );
  });

  const CommentGrid = () => {
    const { data } = useListContext();
    const [categoryListItems, setCategoryListItems] = useState(
      Object.entries(data).map((d) => d[1])
    );

    useEffect(() => {
      const categories = Object.entries(data).map((d) => d[1]);
      const orderedCategories = categories.sort(
        (a: any, b: any) => a.order - b.order
      );

      setCategoryListItems(orderedCategories);
    }, [data]);

    const onSortEnd = (props: any) => {
      const orderedCategory = arrayMove(
        categoryListItems,
        props.oldIndex,
        props.newIndex
      );
      setCategoryListItems(orderedCategory);
      updateAll(orderedCategory);
    };

    return (
      <SortableList
        items={categoryListItems}
        onSortEnd={onSortEnd}
        distance={10}
        useDragHandle={true}
      />
    );
  };

  return (
    <List
      {...props}
      title={translate(`custom.menu.${props.resource}`)}
      exporter={false}
      bulkActionButtons={false}
      actions={false}
      filter={false}
      pagination={false}
      perPage={1000}
      sort={{ field: "order", order: "ASC" }}
    >
      <Container>
        <Content>
          <HeaderRow>
            <Title>Categorias</Title>
            <Actions>
              <CreateButton href="#/category/create">+ Criar categoria</CreateButton>
            </Actions>
          </HeaderRow>
          <ListCard>
            <CommentGrid />
          </ListCard>
          <ListHint>Arraste para reordenar as categorias.</ListHint>
        </Content>
      </Container>
    </List>
  );
};

export const CategoryCreate = (props: any) => {
  const translate = useTranslate();
  const redirect = useRedirect();

  const transform = async (data: any) => {
    if (data.availableDays) {
      data.availableDays = {
        friday: data.availableDays?.friday ?? false,
        monday: data.availableDays?.monday ?? false,
        saturday: data.availableDays?.saturday ?? false,
        sunday: data.availableDays?.sunday ?? false,
        thursday: data.availableDays?.thursday ?? false,
        tuesday: data.availableDays?.tuesday ?? false,
        wednesday: data.availableDays?.wednesday ?? false,
      };
    }

    return {
      ...data,
    };
  };

  return (
    <Create
      {...props}
      undoable={false}
      transform={(data: any) => transform(data)}
      title={translate(`custom.menu.${props.resource}`)}
      onSuccess={() => {
        redirect("/category");
      }}
    >
      <SimpleForm>
        <Container>
          <Content>
            <HeaderRow>
              <Title>Categoria</Title>
            </HeaderRow>
            <FormCard>
              <TextInput
                source="name"
                label={translate("custom.entities.category.name")}
                fullWidth={true}
              />
              <Grid
                item
                container
                direction="row"
                alignItems="flex-start"
                xs={12}
                style={{ width: "100%" }}
              >
                {/* <p style={{ width: "100%" }} className="MuiFormHelperText-root">
                  Dias disponíveis
                </p>
                <BooleanInput source="availableDays.sunday" label={"Dom"} />
                <BooleanInput source="availableDays.monday" label={"Seg"} />
                <BooleanInput source="availableDays.tuesday" label={"Ter"} />
                <BooleanInput source="availableDays.wednesday" label={"Qua"} />
                <BooleanInput source="availableDays.thursday" label={"Qui"} />
                <BooleanInput source="availableDays.friday" label={"Sex"} />
                <BooleanInput source="availableDays.saturday" label={"Sab"} /> */}
              </Grid>
            </FormCard>
          </Content>
        </Container>
      </SimpleForm>
    </Create>
  );
};

export const CategoryEdit = (props: any) => {
  const translate = useTranslate();

  return (
    <Edit {...props} title={translate(`custom.menu.${props.resource}`)}>
      <SimpleForm>
        <Container>
          <Content>
            <HeaderRow>
              <Title>Categoria</Title>
            </HeaderRow>
            <FormCard>
              <TextInput
                source="name"
                label={translate("custom.entities.category.name")}
                fullWidth={true}
              />
              <Grid
                item
                container
                direction="row"
                alignItems="flex-start"
                xs={12}
                style={{ width: "100%" }}
              >
                {/* <p style={{ width: "100%" }} className="MuiFormHelperText-root">
                  Dias disponíveis
                </p>
                <BooleanInput source="availableDays.sunday" label={"Dom"} />
                <BooleanInput source="availableDays.monday" label={"Seg"} />
                <BooleanInput source="availableDays.tuesday" label={"Ter"} />
                <BooleanInput source="availableDays.wednesday" label={"Qua"} />
                <BooleanInput source="availableDays.thursday" label={"Qui"} />
                <BooleanInput source="availableDays.friday" label={"Sex"} />
                <BooleanInput source="availableDays.saturday" label={"Sab"} /> */}
              </Grid>
            </FormCard>
          </Content>
        </Container>
      </SimpleForm>
    </Edit>
  );
};
